import Cookies from "js-cookie";

const MUTATING_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

// L-01 (MA-06): for the handful of ApiCalls/*.js files that call fetch() directly
// instead of going through fetchWrapper/axiosWithAuth. Every request to our own
// backend needs `credentials: "include"` so the httpOnly mantis_session cookie is
// sent (and any Set-Cookie response is stored) across our cross-origin subdomains,
// plus the CSRF header on mutating requests.
export function withAuthCredentials(options = {}) {
  const method = (options.method || "GET").toUpperCase();
  const headers = { ...(options.headers || {}) };
  
  // Clean up any case-insensitive duplicate headers to prevent sending the token twice
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === "x-csrf-token") {
      delete headers[key];
    }
  }

  if (MUTATING_METHODS.has(method)) {
    const csrfToken = Cookies.get("csrfToken");
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken;
  }
  return { ...options, headers, credentials: "include" };
}
